import { ProceduralPoolGrid, PROC_SURFACE_IDS } from '../../../../Pool/logic/ProceduralPoolGrid';
import { getSkimmerModelParams, getBaseHeight, getWallOffset } from './positioning';
import { SKIMMER_CONFIG } from './config';

/**
 * Рассчитать слоты для скиммеров
 */
export const calculateSkimmerSlots = (poolDimensions, quantity = 1, poolType = 'скиммерный') => {
    const { length, width, depth } = poolDimensions;

    // Инициализируем новую систему сетки
    const gridSystem = new ProceduralPoolGrid(length, width, depth, poolType);
    const isLengthMain = length >= width;
    const targetSurfaceId = isLengthMain ? PROC_SURFACE_IDS.WALL_RIGHT : PROC_SURFACE_IDS.WALL_FRONT;

    const options = {
        padding: 0,
        offset: 0,
        fixedHeight: null,
        distributionMode: 'equal_gaps'
    };

    // Используем distributeEvenly для равномерной расстановки
    const slots = gridSystem.distributeEvenly(targetSurfaceId, quantity, options);

    // Добавляем ID и сторону
    return slots.map((slot, index) => ({
        ...slot,
        id: `skimmer-${index}`,
        side: targetSurfaceId
    }));
};

/**
 * Рассчитать финальные позиции скиммеров для рендера
 */
export const calculateSkimmerPositions = (poolDimensions, quantity, poolType, skimmerModel = null, skimmerName = 'EM0010') => {
    // 1. Получаем слоты (координаты + поворот + нормаль)
    const slots = calculateSkimmerSlots(poolDimensions, quantity, poolType);

    // 2. Обогащаем данными модели (масштаб, компенсация высоты)
    const { length, width, depth } = poolDimensions;
    const gridSystem = new ProceduralPoolGrid(length, width, depth, poolType);
    const wallTopY = gridSystem.dims.wallCenterY + gridSystem.dims.wallHeight / 2;
    const topEdgeExtraDrop = SKIMMER_CONFIG.POSITIONING.TOP_EDGE_EXTRA_DROP ?? 0;

    return slots.map(slot => {
        const isLengthPositioning = Math.abs(slot.normal[0]) > 0.01;
        const params = getSkimmerModelParams(skimmerName, depth, length, width, isLengthPositioning);
        // Позиция Y относительно верхней кромки внутренней стены чаши.
        // Это гарантирует корректную установку скиммера "у борта"
        // при любой глубине бассейна.
        let y = wallTopY;

        // Смещение центра скиммера относительно кромки воды (базовая высота из конфига)
        const baseHeight = getBaseHeight(skimmerName);
        y -= baseHeight;
        y -= topEdgeExtraDrop;

        // Применяем координаты слота (X, Z)
        let { x, z } = slot;

        // 1. Компенсация высоты 
        y += params.heightCompensation;

        // 2. Смещение от стены (базовое)
        const wallOffsetBase = getWallOffset(skimmerName);
        x -= slot.normal[0] * (params.wallOffsetCompensation + wallOffsetBase);
        z -= slot.normal[2] * (params.wallOffsetCompensation + wallOffsetBase);

        // 4. Протрузия (выступ)
        x -= slot.normal[0] * params.protrusionOffset;
        z -= slot.normal[2] * params.protrusionOffset;

        // 5. Поворот
        const baseRotation = slot.rotation;
        const rotation = [
            baseRotation[0],
            baseRotation[1] + Math.PI,
            baseRotation[2]
        ];

        return {
            ...slot,
            x, y, z,
            position: [x, y, z],
            rotation,
            scale: params.scale,
            skimmerName,
            isLengthPositioning
        };
    });
};
